type InformationAboutDeletionType = {
  app: 'SKEZIA' | 'SKEMEET';
  description: string;
  role?: 'USER' | 'PARTICIPANT';
};

export const informationAboutDeletion: InformationAboutDeletionType[] = [
  {
    app: 'SKEZIA',
    description: "Vous perdez l'accès à SKEZIA et aux projets où vous collaborez",
    role: 'USER',
  },
  {
    app: 'SKEZIA',
    description: 'Vos projets et les données collectées seront supprimés',
    role: 'USER',
  },
  {
    app: 'SKEZIA',
    description: 'Si vous en possédez, votre abonnement ou votre licence sera résiliée',
    role: 'USER',
  },
  {
    app: 'SKEZIA',
    description: "Vous perdez l'accès à l'ensemble des projets auxquels vous participez",
    role: 'PARTICIPANT',
  },
  {
    app: 'SKEZIA',
    description:
      "Vous serez désinscrit(e) des projets auxquels vous participez selon les conditions de leurs notes d'information. Nous vous invitons à les consulter pour savoir comment seront gérées vos données",
    role: 'PARTICIPANT',
  },
  {
    app: 'SKEMEET',
    description: "Vous perdez l'accès à SKEMEET et aux téléexpertises",
  },
  {
    app: 'SKEMEET',
    description: 'Vos RCP, vos patients et leurs données seront supprimés',
  },
  {
    app: 'SKEMEET',
    description: 'Si vous en possédez, votre organisation sera supprimée et votre licence résiliée',
  },
];
